import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  locationPlace: [],
  namePlace: "",
  isSearchPlace: false,
};

const searchPlaceSlice = createSlice({
  name: "searchPlace",
  initialState,
  reducers: {
    setSearchPlace: (state, action) => {
      state.isSearchPlace = action.payload.isSearchPlace;
    },
    setNamePlace: (state, action) => {
      state.namePlace = action.payload.namePlace;
    },
    setLocationPlace: (state, action) => {
      state.locationPlace = action.payload.locationPlace;
    },
    clearSearchPlace: (state) => {
      state.isSearchPlace = false;
      state.namePlace = "";
      state.locationPlace = [];
    },
  },
});

export const {
  setSearchPlace,
  setNamePlace,
  setLocationPlace,
  clearSearchPlace,
} = searchPlaceSlice.actions;
export default searchPlaceSlice.reducer;
